import type { HotelInput } from "@/lib/gql/__generated__/graphql";

import type { HotelSettingsHotelInfoFormModel } from "../../../../type";

type Props = {
	viewModel: HotelSettingsHotelInfoFormModel["ViewModel"];
};

export const viewModelToInputConverter = ({ viewModel }: Props): HotelInput => {
	const input: HotelInput = {
		companyID: viewModel.companyID,
		hotelID: viewModel.hotelID,

		address: viewModel.address
			? {
					city: viewModel.address.city?.value,
					nationality: viewModel.address.nationality?.value,
					pref: viewModel.address.pref?.value,
					postalCode: viewModel.address.postalCode?.value,
					state: viewModel.address.state?.value,
					other: viewModel.address.other?.value,
					town: viewModel.address.town?.value,
				}
			: undefined,
		catchCopy: viewModel.catchCopy?.value || undefined,
		customTypeRoomTitle: viewModel.customTypeRoomTitle?.value || undefined,
		email: viewModel.email?.value || undefined,
		facebookURL: viewModel.facebookURL?.value || undefined,
		geoLocation:
			viewModel.geoLocation?.lat?.value && viewModel.geoLocation?.lon?.value
				? {
						lat: viewModel.geoLocation.lat.value,
						lon: viewModel.geoLocation.lon.value,
					}
				: undefined,
		inSale: viewModel.inSale.value,
		instagramURL: viewModel.instagramURL?.value || undefined,
		keyVisuals: viewModel.keyVisuals?.value
			? viewModel.keyVisuals.value.map((keyVisual) => ({
					bucket: keyVisual.bucket.value,
					key: keyVisual.key.value,
					region: keyVisual.region.value,
					mimeType: keyVisual.mimeType?.value,
					fileName: keyVisual.fileName?.value,
				}))
			: undefined,
		logoImage: viewModel.logoImage
			? {
					bucket: viewModel.logoImage.bucket?.value,
					key: viewModel.logoImage.key?.value,
					region: viewModel.logoImage.region?.value,
					mimeType: viewModel.logoImage.mimeType?.value,
					fileName: viewModel.logoImage.fileName?.value,
				}
			: undefined,
		mainKeyVisual: viewModel.mainKeyVisual
			? {
					bucket: viewModel.mainKeyVisual.bucket?.value,
					key: viewModel.mainKeyVisual.key?.value,
					region: viewModel.mainKeyVisual.region?.value,
					mimeType: viewModel.mainKeyVisual.mimeType?.value,
					fileName: viewModel.mainKeyVisual.fileName?.value,
				}
			: undefined,
		name: viewModel.name.value,
		tel: viewModel.tel?.value || undefined,
		threadsURL: viewModel.threadsURL?.value || undefined,
		lineURL: viewModel.lineURL?.value || undefined,
		twitterURL: viewModel.twitterURL?.value || undefined,
	} satisfies HotelInput;

	return input;
};
